/**
 * Marquee.jsx — Eindeloze scrollende banner
 * Gebruik: <Marquee items={[...]} speed={30} dark />
 */
import React from 'react';

export default function Marquee({ items = [], speed = 35, dark = false, size = 'md' }) {
  const doubled = [...items, ...items]; // duplicate for seamless loop
  const duration = `${Math.round(items.length * speed)}s`;

  const textSize = size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm';

  return (
    <div className={`overflow-hidden py-3 ${dark ? 'bg-[#0f172a]' : 'bg-[#f8fafc] border-y border-gray-100'}`}>
      <div className="flex items-center gap-0" style={{ width: 'max-content', animation: `marquee ${duration} linear infinite` }}>
        {doubled.map((item, i) => (
          <div key={i} className={`flex items-center gap-2 px-6 whitespace-nowrap ${textSize} font-semibold ${dark ? 'text-white/60' : 'text-[#64748b]'}`}>
            {item.icon && <span className="text-[#D4A017]">{item.icon}</span>}
            <span>{item.text || item}</span>
            <span className={`mx-2 ${dark ? 'text-white/20' : 'text-gray-300'}`}>·</span>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
